export type LegalBlock = {
  type: "title" | "heading" | "paragraph" | "listItem";
  text: string;
};

export type LegalDocument = {
  key: string;
  slug: string;
  title: string;
  blocks: readonly LegalBlock[];
};

export const legalDocuments = [
  {
    "key": "legalMentions",
    "slug": "mentions-legales",
    "title": "Mentions légales",
    "blocks": [
      {
        "type": "title",
        "text": "Mentions légales"
      },
      {
        "type": "paragraph",
        "text": "Veuillez lire attentivement les présentes Mentions Légales"
      },
      {
        "type": "heading",
        "text": "1- Éditeur"
      },
      {
        "type": "paragraph",
        "text": "ALINÉA Plus\n8, rue Froidevaux 75014 PARIS\nTél : 01 46 67 62 53 – Fax : 01 41 38 12 02\ncontact@ePOPI.fr\nSAS au capital de 10 000 €\nRCS Paris 753 930 445 – TVA Intracommunautaire FR55 753 930 445"
      },
      {
        "type": "paragraph",
        "text": "Directeur de la publication du site www.epopi.fr\nNadège LEFEBVRE : nadege.lefebvre@alineaplus.fr"
      },
      {
        "type": "paragraph",
        "text": "Abonnements : support@epopi.fr"
      },
      {
        "type": "paragraph",
        "text": "2-Hébergeur"
      },
      {
        "type": "paragraph",
        "text": "www.epopi.fr est hébergé, sur un serveur dédié Alinéa Plus et protégé, par la société OVHcloud pour la conservation et le traitement des données soumises. OVHcloud est immatriculée au RCS de Lille Métropole sous le numéro 424761419 et domiciliée au 2 rue Kellermann à Roubaix. Elle est joignable au téléphone au +33972 10 10 07."
      },
      {
        "type": "heading",
        "text": "3- Rédaction"
      },
      {
        "type": "paragraph",
        "text": "Collège des universitaires de Maladies Infectieuses et Tropicales (CMIT)\nSiège social : CMIT - Maison de l'Infectiologie 21 rue Beaurepaire 75010 PARIS\nPrésident du CMIT :"
      },
      {
        "type": "paragraph",
        "text": "Pr Charles Cazanave\nCHU Bordeaux – Hôpital Pellegrin - Service des Maladies Infectieuses et Tropicales - Place Amélie Raba-Léon - 33076 Bordeaux Cedex"
      },
      {
        "type": "paragraph",
        "text": "Responsable des Ouvrages Pédagogiques du CMIT :"
      },
      {
        "type": "paragraph",
        "text": "Pr Florent Valour - Hôpital de la Croix Rousse - Service des Maladies Infectieuses et Tropicales - 103 Grande Rue de la Croix Rousse - 69317 Lyon Cedex 04"
      },
      {
        "type": "paragraph",
        "text": "Coordonnateurs du Comité Éditorial et de veille ePOPI :"
      },
      {
        "type": "paragraph",
        "text": "Pr Christian Chidiac\nUFR Lyon Sud - Charles Mérieux Et Centre Médical et de Vaccination Internationale - ELSAN - 155 ter boulevard Stalingrad - 69006 Lyon"
      },
      {
        "type": "paragraph",
        "text": "Pr Bruno HOEN\nService des Maladies Infectieuses et Tropicales - CHU de Besançon – Université de Lorraine - 3, boulevard Fleming - 25030 Besançon Cedex"
      },
      {
        "type": "paragraph",
        "text": "Pr Odile Launay\nCIC de Vaccinologie Cochin-Pasteur - Pôle de Médecine - Hôpital Cochin\n27 rue du Faubourg Saint-Jacques - 75679 Paris Cedex 14"
      },
      {
        "type": "heading",
        "text": "4- Charte ePOPI"
      },
      {
        "type": "paragraph",
        "text": "Le site www.epopi.fr est régis par une charte disponible sur le site (Charte ePOPI) ayant trait aux points suivants :"
      },
      {
        "type": "paragraph",
        "text": "le Comité éditorial et le Comité scientifique,"
      },
      {
        "type": "paragraph",
        "text": "l’objectif du ePOPI,"
      },
      {
        "type": "paragraph",
        "text": "le public visé,"
      },
      {
        "type": "paragraph",
        "text": "l’élaboration collégiale,"
      },
      {
        "type": "paragraph",
        "text": "la méthodologie d’élaboration,"
      },
      {
        "type": "paragraph",
        "text": "l’indépendance et la responsabilité,"
      },
      {
        "type": "paragraph",
        "text": "le financement,"
      },
      {
        "type": "paragraph",
        "text": "la confidentialité et la protection des données personnelles conformes au RGPD"
      },
      {
        "type": "heading",
        "text": "5 - NOUS CONTACTER"
      },
      {
        "type": "paragraph",
        "text": "ALINEA Plus"
      },
      {
        "type": "paragraph",
        "text": "8, rue Froidevaux"
      },
      {
        "type": "paragraph",
        "text": "75014 PARIS"
      },
      {
        "type": "paragraph",
        "text": "Fabienne Feuillade – Service commercial - Contrats des établissements : fabienne.feuillade@alineaplus.fr - 01 41 38 37 85"
      },
      {
        "type": "paragraph",
        "text": "Nadège LEFEBVRE – Directrice des opérations : nadege.lefebvre@alineaplus.fr - 01 41 38 37 86"
      },
      {
        "type": "paragraph",
        "text": "Marie-Laure Ducoudray – Administration des ventes : ml.ducoudray@alineaplus.fr - 01 46 67 62 53"
      }
    ]
  },
  {
    "key": "termsOfUse",
    "slug": "conditions-generales-utilisation",
    "title": "Conditions générales d'utilisation",
    "blocks": [
      {
        "type": "title",
        "text": "Conditions générales d'utilisation"
      },
      {
        "type": "paragraph",
        "text": "Les présentes Conditions Générales d’Utilisation (ci-après « CGU ») ont pour objet de définir les modalités et conditions dans lesquelles les utilisateurs accèdent au site internet www.epopi.fr (ci-après « le Site ») et utilisent les services proposés par ePOPi, accessible via une plateforme en ligne."
      },
      {
        "type": "paragraph",
        "text": "Les CGU constituent un contrat entre l’utilisateur (l’ « Utilisateur » ou « vous ») et ALINÉA Plus. Toute navigation ou utilisation des services implique l’acceptation pleine, entière et sans réserve des présentes CGU."
      },
      {
        "type": "paragraph",
        "text": "Le Site ePOPi est édité par ALINÉA Plus (« ALINÉA Plus », la « Société » ou « nous »), dont les coordonnées figurent dans les mentions légales."
      },
      {
        "type": "heading",
        "text": "Présentation du service ePOPI"
      },
      {
        "type": "paragraph",
        "text": "Le service ePOPI (Guide pratique d’aide à la prescription des anti-infectieux), ci-après dénommé le « Service » est une plateforme de référence destinée aux professionnels de santé, pour les accompagner dans la prescription des anti-infectieux et la mise en œuvre des stratégies de prévention, notamment vaccinales. Un outil d’aide à la prescription des antibiotiques fondé sur les recommandations du Collège des Universitaires de Maladies Infectieuses et Tropicales (CMIT) est mis à disposition. Un outil d’aide à l’administration des antibiotiques fondé sur les données scientifiques de la SFPC (Société de Pharmacie Clinique) est également disponible. Le service intègre également l’accès au service MesVaccins.net facilitant la prescription et la planification vaccinale, élaboré par l’association Groupe d’Etudes en Préventologie (GEP)."
      },
      {
        "type": "heading",
        "text": "Accès au service"
      },
      {
        "type": "paragraph",
        "text": "2.1 Conditions générales d’accès : L’accès au Site ePOPi est réservé aux professionnels de santé habilités à prescrire, délivrer ou administrer des médicaments ou vaccins dans le cadre de leur pratique professionnelle. En accédant au Service, vous déclarez expressément remplir ces conditions."
      },
      {
        "type": "paragraph",
        "text": "L’accès au Site nécessite la création préalable d’un compte personnel. L’Utilisateur s’engage à fournir des informations exactes, complètes et à jour lors de son inscription, notamment en ce qui concerne sa qualité de professionnel de santé. Toute usurpation ou usage frauduleux d’une qualité professionnelle pourra entraîner la suspension immédiate et sans préavis du compte concerné."
      },
      {
        "type": "paragraph",
        "text": "2.2 Compte utilisateur : L’ouverture d’un compte donne accès à un espace utilisateur personnel et sécurisé. Chaque Utilisateur est responsable du maintien de la confidentialité de ses identifiants de connexion (nom d’utilisateur et mot de passe) et s’engage à ne pas les divulguer à des tiers. Toute connexion effectuée au moyen de ces identifiants sera présumée avoir été effectuée par l’Utilisateur lui-même, sauf preuve contraire."
      },
      {
        "type": "paragraph",
        "text": "En cas de perte, de vol ou d’utilisation non autorisée de ses identifiants, l’Utilisateur s’engage à informer immédiatement ALINÉA Plus afin qu’elle puisse prendre les mesures nécessaires à la sécurisation du compte."
      },
      {
        "type": "paragraph",
        "text": "2.3 Compatibilité technique : Le service est accessible via un navigateur internet depuis un ordinateur, une tablette ou un smartphone. L’accès au service mobile ne nécessite pas de téléchargement spécifique, mais requiert une connexion Internet stable. Il appartient à l’Utilisateur de s’assurer que son environnement technique (matériel, logiciel, connexion) est compatible avec les exigences du Site."
      },
      {
        "type": "paragraph",
        "text": "Le site ePOPI est une Progressive Web App (PWA). Une PWA est une application web qui se consulte aussi bien sur un ordinateur que sur un smartphone. epopi.fr peut être consulté sans connexion internet. Cependant, il faudra une connexion internet régulière pour mettre à jour les données."
      },
      {
        "type": "heading",
        "text": "Abonnement et conditions financières"
      },
      {
        "type": "paragraph",
        "text": "L’accès au service ePOPi est soumis à la souscription d’un abonnement payant, personnel et réservé aux professionnels de santé. Les modalités commerciales applicables – incluant la durée, les tarifs, le paiement, la facturation, le renouvellement et les conditions de résiliation – sont régies par les Conditions Générales de Vente (CGV) disponibles sur le site."
      },
      {
        "type": "heading",
        "text": "Niveaux de service"
      },
      {
        "type": "paragraph",
        "text": "4.1 ALINÉA Plus, sur la base d'une obligation de moyens, s’efforce de maintenir en permanence l'accès au Site et s’engage à procéder régulièrement à des contrôles afin de vérifier son fonctionnement et son accessibilité. À ce titre, il est possible que des interruptions temporaires, notamment pour maintenance ou mise à jour surviennent. Nous faisons notre maximum pour vous informer de ces périodes de maintenance et limiter votre gêne en les prévoyant autant que possible à des horaires de faible utilisation. ALINÉA Plus ne saurait être tenue responsable de l’impossibilité temporaire d’accès au service."
      },
      {
        "type": "heading",
        "text": "Utilisation du Service"
      },
      {
        "type": "listItem",
        "text": "5.1 Usage strictement personnel : L’accès au service ePOPi est strictement personnel, nominatif et réservé à l’usage professionnel du titulaire du compte. Toute utilisation du service à des fins commerciales, promotionnelles, de diffusion publique ou de mutualisation entre plusieurs utilisateurs à partir d’un même compte est interdite."
      },
      {
        "type": "listItem",
        "text": "L’Utilisateur s’engage à ne pas partager ses identifiants, ni à permettre à un tiers – y compris un autre professionnel de santé – d’accéder au service via son compte. En cas de non-respect de cette règle, ALINÉA Plus se réserve le droit de suspendre ou de supprimer l’accès au compte concerné, sans préavis ni remboursement."
      },
      {
        "type": "listItem",
        "text": "5.2 Utilisation attendue : L’Utilisateur s’engage à utiliser le Site et ses contenus dans le respect des présentes CGU, de la réglementation en vigueur et des règles déontologiques applicables à sa profession."
      },
      {
        "type": "listItem",
        "text": "5.3 Utilisation prohibée : Sont strictement prohibées, sans que cette liste soit limitative :"
      },
      {
        "type": "listItem",
        "text": "tous comportements de nature à interrompre, suspendre, ralentir ou empêcher l'accès au Site,"
      },
      {
        "type": "listItem",
        "text": "tout détournement ou modification des contenus proposés sur le Site,"
      },
      {
        "type": "listItem",
        "text": "toute extraction massive ou systématique des données, notamment à l’aide de scripts ou de robots,"
      },
      {
        "type": "listItem",
        "text": "toute tentative d’accéder de manière non autorisée à tout ou partie du Site, de son code source ou à des bases de données,"
      },
      {
        "type": "listItem",
        "text": "toutes actions de nature à imposer une charge disproportionnée sur nos infrastructures,"
      },
      {
        "type": "listItem",
        "text": "la mise à disposition du service au profit de tiers, sans accord préalable ;"
      },
      {
        "type": "listItem",
        "text": "toute action visant à monnayer, vendre, prêter ou concéder tout ou partie de l'accès aux Services ou au Site, ainsi qu'aux informations qui y sont hébergées et/ou partagées."
      },
      {
        "type": "listItem",
        "text": "toute utilisation contraire aux lois relatives à la santé publique, à la propriété intellectuelle, ou à la confidentialité des données."
      },
      {
        "type": "listItem",
        "text": "En cas de manquement constaté, ALINÉA Plus pourra prendre toute mesure nécessaire, incluant la suspension ou suppression du compte, des poursuites civiles ou pénales, et le cas échéant, l’information des autorités compétentes."
      },
      {
        "type": "heading",
        "text": "Propriété intellectuelle"
      },
      {
        "type": "paragraph",
        "text": "6.1 L’ensemble des éléments figurant sur le Site ePOPi – notamment les textes, recommandations thérapeutiques, bases de données, arborescences, algorithmes, graphismes, logos, noms de domaine, marques, ainsi que le design général (le « Contenu »)– est protégé par les législations en vigueur sur le droit d’auteur, le droit des bases de données et les droits de propriété intellectuelle."
      },
      {
        "type": "paragraph",
        "text": "Sauf mention contraire, ces contenus sont la propriété exclusive d’ALINÉA Plus ou de ses partenaires."
      },
      {
        "type": "paragraph",
        "text": "6.2 En souscrivant à un abonnement individuel annuel ePOPI, l’abonné s’inscrit comme utilisateur et obtient une licence temporaire et personnelle d’utilisation du site www.epopi.fr et un droit d’impression ou de copie à usage privé, en indiquant la source et les mentions de droit d’auteur et autres mentions de droit de propriété. Chaque licence et droit d’impression ou de copie à usage privé sont attachés à un identifiant et un mot de passe."
      },
      {
        "type": "paragraph",
        "text": "6.3 L’utilisation collective d’une licence et/ou du droit de copie est interdite sauf dans le cadre d'un abonnement collectif lié à un établissement ou à un groupe d'établissements. L'établissement ou le groupe d'établissements obtient auprès d’ALINÉA Plus une licence temporaire d’utilisation du site www.epopi.fr uniquement pour ses terminaux informatiques internes et pour les personnels affiliés, via une ou plusieurs adresses IP communiquées à ALINÉA Plus, et selon une grille tarifaire tenant compte de la taille de l'établissement ou du groupe d'établissements déterminée par le nombre de praticiens ou de lits, figurant explicitement sur les devis et factures d'abonnements établis par ALINÉA Plus."
      },
      {
        "type": "paragraph",
        "text": "Toute utilisation du ePOPI au-delà des droits d'usage consentis, soit à travers un réseau informatique local, régional, national ou international, soit par communication de la clé d'identification confidentielle et spécifique à l'établissement, est illicite et frauduleuse."
      },
      {
        "type": "paragraph",
        "text": "Chaque établissement ou groupe d'établissements doit s'assurer de la non-utilisation possible de ses droits d'usage ePOPI par un autre établissement ou un autre tiers et est seul responsable de l'utilisation frauduleuse via son réseau informatique qui est de son ressort exclusif."
      },
      {
        "type": "paragraph",
        "text": "En cas d'utilisation illicite ou frauduleuse avérée et constatée par Alinéa Plus ou le CMIT, Alinéa Plus en avertit l'établissement et la connexion ePOPI est immédiatement interrompue sans aucun dédommagement. Elle ne pourra reprendre dans le cadre de l'abonnement consenti qu'après résolution du problème par l'établissement abonné, seul responsable de son réseau informatique et de l'utilisation de ses droits d'usage ePOPI."
      },
      {
        "type": "paragraph",
        "text": "Toute représentation, traduction, diffusion et/ou exploitation ou reproduction même partielle du Contenu, quel que soit le procédé, faite sans l’autorisation écrite et préalable d’ALINÉA Plus, est illicite et constitue une contrefaçon."
      },
      {
        "type": "paragraph",
        "text": "6.3 Protection des bases de données : Les bases de données figurant sur le Site sont protégées par le droit sui generis du producteur de bases de données. Toute extraction ou réutilisation substantielle ou répétée de ces données est strictement interdite."
      },
      {
        "type": "paragraph",
        "text": "6.4 Retours d’expérience : Dans le cadre des présentes CGU, l’Utilisateur peut fournir des suggestions, des demandes d’amélioration, des recommandations concernant les Services ou tout autre commentaire (les « Retours d’expérience »). Dans ce cadre, tous les droits de propriété intellectuelle en résultant reviendront à ALINÉA Plus ou ses partenaires scientifiques. Vous nous accordez une licence gratuite, mondiale, cessible, irrévocable et perpétuelle pour implémenter, utiliser, modifier, exploiter commercialement, incorporer aux Services ou utiliser de toute autre manière tout Retour d’expérience. Nous nous réservons également le droit de protéger par des droits de propriété intellectuelle toute fonctionnalité, tout composant ou toute amélioration pouvant découler de ce Retour d’expérience ou en être à l’origine."
      },
      {
        "type": "heading",
        "text": "Responsabilité"
      },
      {
        "type": "paragraph",
        "text": "7.1 Nous nous engageons à mettre en œuvre nos meilleurs moyens, sans être soumis à une quelconque obligation de résultat, un service fiable, accessible et scientifiquement rigoureux. Toutefois, malgré le soin apporté à l’élaboration et à la mise à jour des contenus, ceux-ci sont fournis à titre informatif et ne sauraient se substituer à l’expertise, au jugement clinique ou à la responsabilité personnelle du professionnel de santé utilisateur."
      },
      {
        "type": "paragraph",
        "text": "ALINÉA Plus ne saurait en aucun cas être tenu responsable :"
      },
      {
        "type": "listItem",
        "text": "d’une erreur, omission, imprécision dans les contenus diffusés ;"
      },
      {
        "type": "listItem",
        "text": "de l’usage fait par l’utilisateur des informations disponibles sur le Site ;"
      },
      {
        "type": "listItem",
        "text": "d’éventuelles conséquences médicales, thérapeutiques ou juridiques résultant de l’application ou de l’interprétation des données par l’utilisateur dans sa pratique."
      },
      {
        "type": "paragraph",
        "text": "7.2. L’Utilisateur est responsable de l’utilisation qu’il fait du service et des conséquences directes ou indirectes qui en résultent. Il lui appartient de vérifier l’adéquation des informations fournies sur le Site avec la situation clinique qu’il rencontre, et d’exercer son jugement professionnel en toutes circonstances."
      },
      {
        "type": "paragraph",
        "text": "Le Service ne saurait se substituer au jugement du professionnel de santé utilisateur. ALINÉA Plus ne peut en aucun cas être tenu responsable des décisions médicales prises sur la base des informations fournies par le Service. Les professionnels santé utilisateurs restent seuls responsables de leurs actes et prescriptions."
      },
      {
        "type": "paragraph",
        "text": "L’Utilisateur garantit qu’il n’utilisera pas le Site de manière à porter atteinte aux droits de tiers ou à l’ordre public, ni à contrevenir à la réglementation applicable à l’exercice de sa profession."
      },
      {
        "type": "paragraph",
        "text": "7.3 En tout état de cause, et sans préjudice de toute clause des CGU et/ou des CGV limitant notre responsabilité, la responsabilité que nous sommes susceptibles d'encourir est expressément limitée aux seuls dommages directs et avérés que vous auriez subis de notre fait."
      },
      {
        "type": "heading",
        "text": "Données personnelles"
      },
      {
        "type": "paragraph",
        "text": "Pour plus d’informations sur la manière dont ePOPi collecte, utilise, protège et conserve vos données personnelles, l’utilisateur est invité à consulter la Politique de confidentialité accessible à tout moment à l’adresse suivante : https://epopi.fr/politique-de-confidentialite"
      },
      {
        "type": "paragraph",
        "text": "Ce document complète les présentes Conditions Générales d’Utilisation et détaille de manière transparente les droits des utilisateurs ainsi que les engagements d’ALINÉA Plus en matière de protection des données personnelles."
      },
      {
        "type": "heading",
        "text": "Tolérance"
      },
      {
        "type": "paragraph",
        "text": "Aucune tolérance sur l’application des dispositions des CGU ne peut être interprétée comme valant renonciation d’ALINÉA Plus à s’en prévaloir ultérieurement."
      },
      {
        "type": "heading",
        "text": "Mises à jour"
      },
      {
        "type": "paragraph",
        "text": "ALINÉA Plus se réserve le droit de modifier à tout moment les présentes CGU, notamment afin de prendre en compte les évolutions législatives ou réglementaires applicables, les évolutions techniques du service ou encore les ajustements éditoriaux, fonctionnels ou commerciaux nécessaires à l’amélioration de la plateforme ePOPi."
      },
      {
        "type": "paragraph",
        "text": "En cas de modification substantielle, les utilisateurs en seront informés par tout moyen approprié (bandeau sur le Site, notification par e-mail, encart dans l’espace utilisateur, etc.). Les nouvelles CGU entreront en vigueur dès leur mise en ligne, sauf mention contraire. En continuant à utiliser le Site après leur publication, l’utilisateur est réputé avoir accepté sans réserve les modifications apportées."
      },
      {
        "type": "heading",
        "text": "Règlement des litiges"
      },
      {
        "type": "paragraph",
        "text": "Nous sommes toujours disposés à examiner une solution amiable avant toute action en justice. En cas d'action judiciaire, le litige sera soumis à la loi française et à la juridiction du Tribunal judiciaire de Paris, ou, à défaut, du tribunal français territorialement compétent."
      },
      {
        "type": "heading",
        "text": "Entrée en vigueur"
      },
      {
        "type": "paragraph",
        "text": "Les présentes conditions générales sont entrées en vigueur le 01/02/2026"
      }
    ]
  },
  {
    "key": "termsOfSale",
    "slug": "conditions-generales-vente",
    "title": "Conditions générales de vente",
    "blocks": [
      {
        "type": "title",
        "text": "Conditions générales de vente"
      },
      {
        "type": "paragraph",
        "text": "Les présentes Conditions Générales de Vente (ci-après « CGV ») encadrent les conditions de vente des services proposés par ALINÉA Plus par le biais du site internet www.epopi.fr (ci-après « le Site »)."
      },
      {
        "type": "paragraph",
        "text": "Les CGV constituent un contrat entre l’utilisateur (l’ « Utilisateur » ou « vous ») et ALINÉA Plus (« ALINÉA Plus », la « Société » ou « nous »), dont les coordonnées figurent dans les mentions légales. L’Utilisateur et ALINÉA Plus étant collectivement désignés comme les « Parties »."
      },
      {
        "type": "heading",
        "text": "Acceptation des CGV"
      },
      {
        "type": "paragraph",
        "text": "Les CGV régissent votre abonnement (« Abonnement ») au Site et l’utilisation des services proposés par ce biais (les « Services »)."
      },
      {
        "type": "paragraph",
        "text": "La souscription d’un Abonnement est réservée aux personnes :"
      },
      {
        "type": "listItem",
        "text": "agissant dans le cadre de leur activité professionnelle, de sorte que le droit de la consommation n’est pas applicable à la présente relation contractuelle, et"
      },
      {
        "type": "listItem",
        "text": "disposant de la pleine capacité juridique pour s'engager ou justifiant le cas échéant d'une autorisation écrite et valable de leur représentant légal. Dans le cas d’un Établissement ou regroupement d’établissement (telle que définie à l’article 4), la personne signant le Bon de Commande est réputée avoir pouvoir pour engager l’Établissement et recevoir les mises à jour des CGU et des CGV au nom et pour le compte de son Établissement."
      },
      {
        "type": "heading",
        "text": "Services ePOPI"
      },
      {
        "type": "paragraph",
        "text": "2.1 Sauf mention contraire dans les CGV ou au bon de commande, l’Abonnement à ePOPI comprend l’ensemble des services suivants :"
      },
      {
        "type": "listItem",
        "text": "les ressources documentaires : fiches (pathologies infectieuses, microorganismes, traitements antiinfectieux, vaccins), ouvrage collectif du Collège des universitaires de Maladies Infectieuses et Tropicales (« CMIT »)"
      },
      {
        "type": "listItem",
        "text": "l’outil d’aide à la décision et à l’utilisation des antibiotiques fondé sur les recommandations du CMIT"
      },
      {
        "type": "listItem",
        "text": "l’accès au service MesVaccins.net facilitant la prescription et la planification vaccinale, élaboré par l’association Groupe d’Études en Préventologie (« GEP »)."
      },
      {
        "type": "paragraph",
        "text": "2.2 Pour accéder aux Services, vous devez créer un compte (un « Compte »), lire et accepter ces CGV et, souscrire à un Abonnement ou faire partie d'un Établissement ayant souscrit à un Abonnement pour vous."
      },
      {
        "type": "paragraph",
        "text": "2.3 Les Services sont améliorés régulièrement. Nous vous préviendrons quinze (15) jours à l'avance en cas de suppression ou de modification majeure d'un service décrit ci-dessus. Les nouvelles fonctionnalités peuvent faire l'objet d'une tarification dans le cadre d'options additionnelles soumises à votre accord."
      },
      {
        "type": "heading",
        "text": "Inscription et Compte"
      },
      {
        "type": "paragraph",
        "text": "3.1 Dans le cadre des Abonnements individuels\nLes Abonnements Individuels sont souscrits directement en ligne. La création d’un Compte requiert la communication de certaines informations, collectées et conservées selon les modalités décrites dans notre Politique de confidentialité : https://epopi.fr/politique-de-confidentialite."
      },
      {
        "type": "paragraph",
        "text": "Les informations communiquées étant notamment utilisées pour la facturation de nos Services, vous vous engagez à nous fournir des informations exactes et sincères, et à les tenir à jour par le biais de la page d'administration de votre Compte. Vous pouvez accéder à l'espace d'administration de votre compte à tout moment en accédant à la page https://epopi.fr/mon-compte. Vous pourrez obtenir une facture en accédant à la page facturation de votre compte : https://epopi.fr/mon-compte/facturation"
      },
      {
        "type": "paragraph",
        "text": "3.2 Dans le cadre des Abonnements Collectifs (établissement ou groupe d’établissement)"
      },
      {
        "type": "paragraph",
        "text": "L’accès au service ePOPi est soumis à la souscription d’un abonnement payant, réservé aux professionnels de santé de l’établissement ou groupe d’établissements."
      },
      {
        "type": "paragraph",
        "text": "Les Abonnements Collectifs font systématiquement l'objet d'un devis et/ou d’un bon de commande. Les Services font l'objet de factures qui vous seront communiquées par email."
      },
      {
        "type": "heading",
        "text": "4. Abonnement et conditions financières"
      },
      {
        "type": "paragraph",
        "text": "4.1 Abonnement Individuel"
      },
      {
        "type": "paragraph",
        "text": "Vous pouvez souscrire à un Abonnement Individuel (un « Abonnement Individuel »). L’Abonnement Individuel est annuel, renouvelable tacitement pour des périodes d’une année et soumis aux CGV en vigueur au moment de son renouvellement."
      },
      {
        "type": "paragraph",
        "text": "4.2 Abonnement Collectif"
      },
      {
        "type": "paragraph",
        "text": "4.2.1 Dans les autres cas, l'établissement ou le groupe d’établissements dont vous faites partie (l’« Établissement ») doit souscrire à un Abonnement collectif (un « Abonnement Collectif »). L'Abonnement Collectif peut être souscrit pour une durée supérieure, auquel cas il est tacitement renouvelé pour cette même durée et soumis aux CGV en vigueur au moment de son renouvellement."
      },
      {
        "type": "paragraph",
        "text": "4.2.2 L’Établissement s’engage à signaler, tout au long de son Abonnement et dans les plus brefs délais, toute modification de sa situation (évolution du nombre de lits ou du nombre de praticiens hospitaliers) pouvant avoir un impact sur sa souscription."
      },
      {
        "type": "paragraph",
        "text": "4.2.3 L'Abonnement Collectif est souscrit par l'Établissement pour L’ensemble des professionnels de santé ayant accès au service epopi.fr sur les terminaux informatiques de l’établissement."
      },
      {
        "type": "paragraph",
        "text": "4.2.4 Une négociation des modalités d'engagement est possible avec le service commercial, joignable par email : fabienne.feuillade@alineaplus.fr. Dans tous les cas, les Abonnements Collectifs font l'objet d'un bon de commande à remplir et renvoyer signé par l'Établissement (le « Bon de commande »). Le Bon de commande précise le prix convenu et toutes conditions particulières négociées par les Parties. Les éventuelles dérogations aux CGV consenties ne sont valables que pour la durée initiale d'engagement. En cas de contradiction entre le Bon de commande et les présentes CGV, le Bon de commande prévaut."
      },
      {
        "type": "paragraph",
        "text": "4.2.5 Le Bon de commande référence ces CGV, dont les dispositions régissent la relation entre ALINÉA Plus et l’Établissement."
      },
      {
        "type": "paragraph",
        "text": "4.2.6 En cas de pluralité de Bons de commande contradictoires, le Bon de commande le plus récent prévaut."
      },
      {
        "type": "heading",
        "text": "5. Prix et conditions de paiement"
      },
      {
        "type": "listItem",
        "text": "5.1 Prix"
      },
      {
        "type": "listItem",
        "text": "Les prix sont les suivants :"
      },
      {
        "type": "paragraph",
        "text": "Abonnement Individuel : Le prix de l’Abonnement individuel est de 33,00 € TTC par an."
      },
      {
        "type": "paragraph",
        "text": "ALINÉA Plus se réserve le droit de réviser le prix. Vous serez informé de tout changement par email au moins quinze (15) jours avant l’entrée en vigueur des nouveaux tarifs."
      },
      {
        "type": "paragraph",
        "text": "Ces nouveaux tarifs ne s’appliquent qu’à la reconduction de votre Abonnement. Vous restez libre de résilier votre Abonnement dans les conditions de l’article 7, qui continuera à courir jusqu’à son terme et ne sera pas renouvelé, si vous n’acceptez pas le changement de tarif. A défaut, vous êtes réputé(e) avoir accepté les nouveaux tarifs. Si le changement de tarif intervient après l’expiration du délai de résiliation de votre Abonnement tel que prévu à l’article 7, vous disposez d’un délai de quinze (15) jours à compter de la notification de changement de tarif pour résilier votre Abonnement."
      },
      {
        "type": "listItem",
        "text": "Abonnement Collectif : Les établissements souhaitant souscrire un abonnement pour leurs affiliés bénéficient d'un tarif spécifique et dégressif. La grille tarifaire tenant compte de la taille de l'établissement ou du groupe d'établissements déterminée par le nombre de praticiens ou de lits est disponible sur simple demande à ALINÉA Plus : fabienne.feuillade@alineaplus.fr"
      },
      {
        "type": "listItem",
        "text": "5.2 Modalités de paiement"
      },
      {
        "type": "paragraph",
        "text": "Abonnement Individuel : le paiement de l’Abonnement Individuel s’effectue uniquement en ligne par carte bancaire à l’aide d’une solution de paiement en ligne Axepta (solution sécurisée avec cryptage des données SSL et respect des exigences de protection DSP2, PCI DSS)."
      },
      {
        "type": "listItem",
        "text": "Abonnement Collectif : le paiement sera effectué par virement bancaire dans un délai de 60 (soixante) jours à compter de la date d’émission de la facture, qui sera établie à la date de souscription."
      },
      {
        "type": "listItem",
        "text": "5.3 Retards et incidents de paiement"
      },
      {
        "type": "paragraph",
        "text": "Tout retard ou incident de paiement de tout ou partie d'une somme due entraîne automatiquement, sans mise en demeure préalable et sans préjudice d'autres actions qu’ALINÉA Plus pourrait intenter :"
      },
      {
        "type": "listItem",
        "text": "la suspension immédiate de l'accès au Service jusqu'au complet paiement de l'intégralité des sommes dues ;"
      },
      {
        "type": "listItem",
        "text": "la facturation d'un intérêt de retard au taux de trois fois le taux de l'intérêt légal en vigueur à la date de la commande, assis sur le montant de l'intégralité des sommes dues. Tout professionnel en situation de retard de paiement est de plein droit débiteur, en sus, d'une indemnité de 40 € pour frais de recouvrement."
      },
      {
        "type": "heading",
        "text": "6. Propriété intellectuelle"
      },
      {
        "type": "paragraph",
        "text": "6.1 L’ensemble des contenus, outils, bases de données, interfaces, documents, textes, éléments graphiques et recommandations accessibles via le Site est protégé par les lois françaises et internationales en vigueur relatives à la propriété intellectuelle et demeurent la propriété exclusive du CMIT et d’ALINÉA Plus ou, le cas échéant, de ses partenaires titulaires des droits."
      },
      {
        "type": "paragraph",
        "text": "6.2 La souscription à un Abonnement Individuel n’emporte aucun transfert de droit de propriété intellectuelle au profit de l’Utilisateur. En souscrivant un Abonnement Individuel, l’Utilisateur obtient une licence temporaire et personnelle d’utilisation du Site et un droit d’impression ou de copie à usage privé, en indiquant la source et les mentions de droit d’auteur et autres mentions de droit de propriété. Chaque licence et droit d’impression ou de copie à usage privé sont attachés à un identifiant et un mot de passe et strictement limité à la durée de l’Abonnement, conformément aux dispositions des Conditions Générales d’Utilisation (CGU) du Service."
      },
      {
        "type": "paragraph",
        "text": "6.3 Dans le cas d’un Abonnement souscrit par Établissement, une licence d’usage non exclusive, non transférable et limitée est accordée à l’Établissement pour le bénéfice de ses utilisateurs autorisés. Une licence temporaire d’utilisation du Site est accordée uniquement pour les terminaux informatiques internes de l’Établissement et pour les personnels affiliés, via une ou plusieurs adresses IP communiquées à ALINÉA Plus et pour un usage interne strictement professionnel. En cas d'abonnement d'un établissement lié à un réseau informatique d'établissements possédant la ou les mêmes adresses IP et si ces autres établissements ne souscrivent pas d'abonnement ePOPI, la connexion et le droit d'accès peuvent s'effectuer à l'aide d'une clé d'identification unique et spécifique à l'établissement, confidentielle, non transférable et fournie par ALINÉA Plus."
      },
      {
        "type": "paragraph",
        "text": "Les droits concédés dans le cadre de cette licence ne peuvent être interprétés comme un transfert de propriété intellectuelle."
      },
      {
        "type": "paragraph",
        "text": "L’Établissement s’engage à faire respecter ces obligations par ses membres et collaborateurs et à informer immédiatement ALINÉA Plus de toute atteinte ou usage frauduleux constaté. En cas de manquement, l’Abonnement pourra être suspendu ou résilié de plein droit, sans préavis ni remboursement, et sans préjudice de tout recours que pourrait engager ALINÉA Plus. L’Abonnement et l’accès au Site ne pourront reprendre qu'après résolution du problème par l'établissement abonné, seul responsable de son réseau informatique et de l'utilisation de ses droits d'usage ePOPI."
      },
      {
        "type": "heading",
        "text": "7. Résiliation de l’Abonnement"
      },
      {
        "type": "paragraph",
        "text": "7.1 Résiliation à l’initiative de l’Utilisateur"
      },
      {
        "type": "paragraph",
        "text": "Les Abonnements individuels peuvent être résiliés à tout moment jusqu’à un mois avant la date d’échéance. Un bouton « Se désabonner » présent sur le site, dans l’espace « Mon abonnement » permet de résilier son abonnement."
      },
      {
        "type": "paragraph",
        "text": "Un courriel de rappel vous sera envoyé deux mois avant la date anniversaire de votre abonnement pour vous informer de votre droit de résiliation."
      },
      {
        "type": "paragraph",
        "text": "La résiliation n’entraîne aucune pénalité et ne donne pas lieu au remboursement de la période en cours, qui court jusqu’à son terme."
      },
      {
        "type": "paragraph",
        "text": "7.2 Résiliation à l’initiative d’ALINÉA Plus"
      },
      {
        "type": "paragraph",
        "text": "ALINÉA Plus se réserve le droit de résilier l'Abonnement de plein droit en cas de non-paiement ou de violation des conditions d'utilisation, dans les conditions suivantes :"
      },
      {
        "type": "paragraph",
        "text": "Mise en demeure préalable : ALINÉA Plus devra notifier à l’Utilisateur, par lettre recommandée avec accusé de réception (ou tout autre moyen équivalent permettant de prouver la réception), une mise en demeure exposant le ou les manquements constatés et lui accordant un délai de [15] jours calendaires pour y remédier."
      },
      {
        "type": "paragraph",
        "text": "Résiliation : si, à l’issue de ce délai, le manquement n’a pas été corrigé, l’Utilisateur pourra résilier le contrat de plein droit, sans autre formalité, par notification écrite."
      },
      {
        "type": "paragraph",
        "text": "Cette résiliation n’exonère pas l’Utilisateur de son obligation de régler les sommes dues au titre de la période contractuelle écoulée ou entamée, ni des dommages-intérêts qu’ALINÉA Plus pourrait solliciter."
      },
      {
        "type": "heading",
        "text": "8. Responsabilité"
      },
      {
        "type": "paragraph",
        "text": "8.1 L’Utilisateur est responsable de l’utilisation qu’il fait du Service et des conséquences directes ou indirectes qui en résultent. Il lui appartient de vérifier l’adéquation des informations fournies sur le Site avec la situation clinique qu’il rencontre, et d’exercer son jugement professionnel en toutes circonstances."
      },
      {
        "type": "paragraph",
        "text": "Le Service ne saurait se substituer au jugement du professionnel de santé utilisateur. ALINÉA Plus ne peut en aucun cas être tenu responsable des décisions médicales prises sur la base des informations fournies par le Service. Les professionnels santé utilisateurs restent seuls responsables de leurs actes et prescriptions."
      },
      {
        "type": "paragraph",
        "text": "L’utilisateur garantit qu’il n’utilisera pas le Site de manière à porter atteinte aux droits de tiers ou à l’ordre public, ni à contrevenir à la réglementation applicable à l’exercice de sa profession."
      },
      {
        "type": "paragraph",
        "text": "8.2 En tout état de cause, et sans préjudice de toute clause des CGV et/ou des CGV limitant notre responsabilité, la responsabilité que nous sommes susceptibles d'encourir est expressément limitée aux seuls dommages directs et avérés que vous auriez subis de notre fait."
      },
      {
        "type": "heading",
        "text": "Données personnelles"
      },
      {
        "type": "paragraph",
        "text": "Pour plus d’informations sur la manière dont ePOPi collecte, utilise, protège et conserve vos données personnelles, l’utilisateur est invité à consulter la Politique de confidentialité accessible à tout moment à l’adresse suivante : https://epopi.fr/politique-de-confidentialite"
      },
      {
        "type": "paragraph",
        "text": "Ce document complète les présentes CGV et détaille de manière transparente les droits des utilisateurs ainsi que les engagements de l’éditeur en matière de protection des données personnelles."
      },
      {
        "type": "heading",
        "text": "Durée du contrat"
      },
      {
        "type": "paragraph",
        "text": "Étant précisé que le contrat s’applique à l’utilisation du Site et à l’accès aux Services par le biais d’un Compte, ces CGV restent en vigueur tant que votre Compte est actif."
      },
      {
        "type": "paragraph",
        "text": "L’Abonnement souscrit dans le cadre des présentes CGV est indépendant de la durée du contrat qui nous lie."
      },
      {
        "type": "heading",
        "text": "Cession"
      },
      {
        "type": "paragraph",
        "text": "ALINÉA Plus peut céder les présentes CGV à une entité affiliée ou dans le cadre d’une fusion, d’un changement de contrôle ou de vente de tout ou partie de ses actifs. Dans une telle hypothèse, ALINÉA Plus vous informera par écrit dans un délai raisonnable. La cession n’emportera aucune modification des obligations essentielles du présent contrat à votre charge."
      },
      {
        "type": "heading",
        "text": "Tolérance"
      },
      {
        "type": "paragraph",
        "text": "Aucune tolérance sur l’application des dispositions des CGV ne peut être interprétée comme valant renonciation d’ALINÉA Plus à s’en prévaloir ultérieurement."
      },
      {
        "type": "heading",
        "text": "Notifications"
      },
      {
        "type": "paragraph",
        "text": "Toutes les notifications que nous vous fournissons dans le cadre des présentes CGV peuvent être envoyées par écrit :"
      },
      {
        "type": "paragraph",
        "text": "par courrier postal à l’adresse postale que vous avez indiqué sur le Bon de commande. En cas de lettre recommandée avec accusé de réception, la lettre est considérée comme reçue dès sa première présentation ;"
      },
      {
        "type": "paragraph",
        "text": "par courrier électronique à l’adresse e-mail que vous avez indiqué le Bon de commande ou le formulaire d’Abonnement."
      },
      {
        "type": "paragraph",
        "text": "Vous devez nous adresser vos notifications par courrier postal à l’adresse suivante : ALINEA Plus 8, rue Froidevaux 75014 PARIS."
      },
      {
        "type": "paragraph",
        "text": "Les notifications seront transmises au titulaire de l’Abonnement, à savoir le signataire du bon de commande. Pour les Abonnements Collectif, l’Établissement s’engage à transmettre les informations notifiées à tous ses Utilisateurs."
      },
      {
        "type": "heading",
        "text": "Mises à jour"
      },
      {
        "type": "paragraph",
        "text": "ALINÉA Plus se réserve le droit de modifier à tout moment les présentes CGV. Toute modification fera l'objet d'une information par tout moyen adéquat quinze (15) jours avant l'entrée en vigueur des nouvelles CGV. Toute utilisation du Site à l'issue de cette période sera soumise aux nouvelles CGV. Pour les Abonnements Collectif, la notification est adressée au signataire du Bon de commande. Vous pouvez nous notifier durant ce délai votre refus des nouvelles conditions, auquel cas les présentes conditions continueront à s'appliquer sans modification."
      },
      {
        "type": "paragraph",
        "text": "Les conditions particulières négociées continuent de s’appliquer pendant la durée de l’Abonnement initial, sans préjudice des modifications ultérieures des CGV. Règlement des litiges"
      },
      {
        "type": "paragraph",
        "text": "Nous sommes toujours disposés à examiner une solution amiable avant toute action en justice. En cas d'action judiciaire, le litige sera soumis à la loi française et à la juridiction du Tribunal judiciaire de Paris, ou, à défaut, du tribunal français territorialement compétent."
      },
      {
        "type": "heading",
        "text": "Entrée en vigueur"
      },
      {
        "type": "paragraph",
        "text": "Les présentes CGV sont entrées en vigueur le 01/02/2026."
      }
    ]
  },
  {
    "key": "privacyPolicy",
    "slug": "politique-de-confidentialite",
    "title": "Politique de confidentialité",
    "blocks": [
      {
        "type": "title",
        "text": "Politique de confidentialité"
      },
      {
        "type": "paragraph",
        "text": "ALINÉA Plus souhaite vous informer des modalités mises en œuvre pour le traitement des données à caractère personnel recueillies sur son site www.epopi.fr (le « Site »)."
      },
      {
        "type": "paragraph",
        "text": "ALINÉA Plus se conforme dans la collecte et la gestion de vos données à la Loi de 1978 modifiée dite « Informatique et Libertés » et au Règlement européen du 27 avril 2016 (le « RGPD»)."
      },
      {
        "type": "heading",
        "text": "Quelles sont les données personnelles susceptibles d’être collectées par ALINÉA Plus ?"
      },
      {
        "type": "listItem",
        "text": "Vos nom, prénom, adresse e-mail, téléphone, adresse, spécialité, lieu d’exercice, service"
      },
      {
        "type": "listItem",
        "text": "Des données techniques collectées automatiquement : notamment adresse IP, données de login ou identifiant similaire, navigateur et version, zone horaire, lieu, cookies (voir ci-dessous Notre politique de cookies), types et versions de « plug-in », systèmes d’exploitation, plate-forme et toute autre technologie sur les appareils que vous utilisez pour accéder à notre Site."
      },
      {
        "type": "listItem",
        "text": "Des données d’usage : notamment la manière d’utiliser notre Site afin d’améliorer la qualité de notre service (voir ci-dessous Notre politique de cookies)."
      },
      {
        "type": "heading",
        "text": "Qui est le responsable du traitement ?"
      },
      {
        "type": "paragraph",
        "text": "Le responsable du traitement des données à caractère personnel est ALINÉA Plus."
      },
      {
        "type": "paragraph",
        "text": "ALINÉA Plus peut être contacté de la manière suivante :\n- Par courrier : 8, rue Froidevaux 75014 PARIS"
      },
      {
        "type": "listItem",
        "text": "Par e-mail : support@epopi.fr"
      },
      {
        "type": "listItem",
        "text": "Par téléphone : +33 1 41 38 37 85"
      },
      {
        "type": "paragraph",
        "text": "Le responsable du traitement des données est chargé de déterminer les finalités et les moyens mis au service du traitement de vos données à caractère personnel."
      },
      {
        "type": "heading",
        "text": "Comment vos données sont-elles collectées ?"
      },
      {
        "type": "listItem",
        "text": "Formulaires (contact, inscription)."
      },
      {
        "type": "listItem",
        "text": "Cookies et technologies similaires."
      },
      {
        "type": "listItem",
        "text": "Logs serveur, outils d’analyse ou de suivi si utilisés."
      },
      {
        "type": "heading",
        "text": "Quelles sont les finalités des traitements mis en place par ALINÉA Plus ?"
      },
      {
        "type": "paragraph",
        "text": "Les données personnelles collectées par ALINÉA Plus sont traitées pour les finalités suivantes :"
      },
      {
        "type": "paragraph",
        "text": "Répondre à vos demandes d’informations concernant les services proposés par ALINÉA Plus."
      },
      {
        "type": "paragraph",
        "text": "Assurer la gestion des commandes, la facturation et la livraison d’ouvrages ou de services."
      },
      {
        "type": "paragraph",
        "text": "Organiser les congrès et gérer l’édition numérique."
      },
      {
        "type": "paragraph",
        "text": "Fournir un support client, effectuer des relances et communiquer sur les événements organisés."
      },
      {
        "type": "paragraph",
        "text": "Élaborer des statistiques de fréquentation et améliorer l’expérience utilisateur sur nos sites et plateformes."
      },
      {
        "type": "paragraph",
        "text": "Préserver un environnement sûr et sécurisé lors de la navigation et de l’utilisation de nos services."
      },
      {
        "type": "heading",
        "text": "Sur quelles bases légales se fondent les traitements mis en place par ALINÉA Plus ?"
      },
      {
        "type": "paragraph",
        "text": "Les traitements de données mis en place par ALINÉA Plus reposent sur les fondements juridiques suivants :"
      },
      {
        "type": "listItem",
        "text": "Exécution d’un contrat : pour la gestion des commandes, la facturation, la livraison d’ouvrages ou de services, ainsi que pour l’organisation des congrès et l’édition numérique."
      },
      {
        "type": "listItem",
        "text": "Intérêt légitime : pour répondre à vos demandes d’information, assurer le support client, gérer la relation avec nos utilisateurs, réaliser des statistiques de fréquentation et préserver un environnement sûr et sécurisé lors de l’utilisation de nos services."
      },
      {
        "type": "heading",
        "text": "Quels sont les destinataires de vos données ?"
      },
      {
        "type": "paragraph",
        "text": "Les personnes suivantes seront susceptibles d’avoir accès à vos données à caractère personnel, dans la limite de leurs attributions respectives :"
      },
      {
        "type": "listItem",
        "text": "Au sein d’ALINÉA Plus :"
      },
      {
        "type": "paragraph",
        "text": "Les membres de l’équipe en charge de la gestion des commandes, de la facturation et du suivi client."
      },
      {
        "type": "paragraph",
        "text": "Le service en charge de l’organisation des congrès, de l’édition numérique et de la communication."
      },
      {
        "type": "paragraph",
        "text": "Les personnels techniques responsables de la maintenance et de la sécurité des systèmes d’information."
      },
      {
        "type": "listItem",
        "text": "Prestataires et sous-traitants externes :"
      },
      {
        "type": "paragraph",
        "text": "Les prestataires d’hébergement et de maintenance informatique."
      },
      {
        "type": "paragraph",
        "text": "Les prestataires logistiques ou de transport pour la livraison d’ouvrages ou services."
      },
      {
        "type": "paragraph",
        "text": "Les prestataires de communication et d’emailing (newsletters, envois promotionnels)."
      },
      {
        "type": "paragraph",
        "text": "Les prestataires d’analyses et de statistiques (outils de mesure d’audience, cookies analytiques)."
      },
      {
        "type": "listItem",
        "text": "Autorités compétentes :"
      },
      {
        "type": "paragraph",
        "text": "Le cas échéant, et uniquement si la loi l’exige, vos données peuvent être transmises aux autorités administratives ou judiciaires habilitées."
      },
      {
        "type": "heading",
        "text": "Quelle est la durée de conservation de mes données ?"
      },
      {
        "type": "paragraph",
        "text": "Vos données à caractère personnel sont conservées uniquement pour la durée nécessaire aux finalités pour lesquelles elles ont été collectées, et conformément aux obligations légales en vigueur :"
      },
      {
        "type": "paragraph",
        "text": "À l’issue de ces délais, les données sont supprimées ou anonymisées afin de ne plus permettre votre identification."
      },
      {
        "type": "heading",
        "text": "Quelle sécurité est mise en place ?"
      },
      {
        "type": "paragraph",
        "text": "ALINÉA Plus, ainsi que ses sous-traitants, mettent en œuvre toutes les précautions nécessaires et des mesures organisationnelles et techniques appropriées afin de préserver la sécurité, l’intégrité et la confidentialité de vos données à caractère personnel."
      },
      {
        "type": "paragraph",
        "text": "Ces mesures incluent notamment :"
      },
      {
        "type": "paragraph",
        "text": "L’hébergement des données sur des serveurs sécurisés situés dans l’Union Européenne."
      },
      {
        "type": "paragraph",
        "text": "Des systèmes de protection contre l’accès non autorisé, la perte, la divulgation ou l’altération des données."
      },
      {
        "type": "paragraph",
        "text": "Des protocoles de sauvegarde et de continuité d’activité afin d’éviter toute perte accidentelle de données."
      },
      {
        "type": "paragraph",
        "text": "La limitation des accès aux seules personnes habilitées dans le cadre de leurs fonctions."
      },
      {
        "type": "paragraph",
        "text": "L’exigence contractuelle de confidentialité et de sécurité imposée à tous les sous-traitants et prestataires intervenant dans le traitement de vos données."
      },
      {
        "type": "paragraph",
        "text": "ALINÉA Plus s’engage cependant à notifier toute violation de données à caractère personnel conformément à la réglementation applicable et, le cas échéant, à informer les personnes concernées."
      },
      {
        "type": "heading",
        "text": "Quels sont vos droits sur vos données ?"
      },
      {
        "type": "paragraph",
        "text": "Conformément à la réglementation applicable en matière de protection des données personnelles (notamment le RGPD), vous disposez des droits suivants :"
      },
      {
        "type": "paragraph",
        "text": "Droit d’accès : obtenir la confirmation que des données personnelles vous concernant sont traitées, et en recevoir une copie."
      },
      {
        "type": "paragraph",
        "text": "Droit de rectification : demander la correction des données inexactes ou incomplètes."
      },
      {
        "type": "paragraph",
        "text": "Droit à l’effacement : demander la suppression de vos données lorsque celles-ci ne sont plus nécessaires ou lorsque vous retirez votre consentement."
      },
      {
        "type": "paragraph",
        "text": "Droit à la limitation du traitement : obtenir la suspension temporaire de l’utilisation de vos données."
      },
      {
        "type": "paragraph",
        "text": "Droit d’opposition : vous opposer, à tout moment, au traitement de vos données pour des raisons tenant à votre situation particulière ou à des fins de prospection."
      },
      {
        "type": "paragraph",
        "text": "Droit à la portabilité : recevoir vos données dans un format structuré, couramment utilisé et lisible par machine, ou demander leur transmission à un autre responsable du traitement."
      },
      {
        "type": "heading",
        "text": "Comment exercer mes droits ?"
      },
      {
        "type": "paragraph",
        "text": "Pour exercer vos droits, la procédure à suivre est toujours la même : envoyer un email à support@epopi.fr."
      },
      {
        "type": "paragraph",
        "text": "Si vous considérez que le traitement de vos données personnelles constitue une violation des textes applicables, vous êtes en droit de saisir la CNIL (Commission Nationale de l’Informatique et des Libertés, https://www.cnil.fr) ou tout juge compétent."
      },
      {
        "type": "heading",
        "text": "Notre politique de cookies"
      },
      {
        "type": "heading",
        "text": "Qu’est-ce qu’un cookie ?"
      },
      {
        "type": "paragraph",
        "text": "Lors de votre navigation sur notre Site des cookies, pixels et autres traceurs (les « Cookies ») sont déposés sur votre navigateur ou terminal."
      },
      {
        "type": "paragraph",
        "text": "Un Cookie est un petit fichier, souvent crypté, stocké dans votre navigateur ou votre terminal et identifié par un nom. Lors de vos visites, il permet de reconnaître votre appareil, de mémoriser certaines informations et d’améliorer votre expérience de navigation. Ces Cookies peuvent nous donner accès à des informations relatives à votre navigation et, dans certains cas, à des données personnelles."
      },
      {
        "type": "heading",
        "text": "Quels types de cookies utilisons-nous ?"
      },
      {
        "type": "paragraph",
        "text": "Nous pouvons utiliser différents types de Cookies :"
      },
      {
        "type": "paragraph",
        "text": "Cookies techniques et fonctionnels (exemptés de consentement) : nécessaires au bon fonctionnement du site, à l’affichage des pages, à la sécurité et, dans certains cas, à la mesure d’audience de manière strictement anonyme."
      },
      {
        "type": "paragraph",
        "text": "Cookies analytiques et de mesure d’audience : permettent d’obtenir des statistiques de fréquentation et d’usage du site afin d’améliorer son ergonomie et son contenu."
      },
      {
        "type": "paragraph",
        "text": "Cookies publicitaires : permettent de proposer des contenus ou publicités adaptés à vos centres d’intérêt."
      },
      {
        "type": "paragraph",
        "text": "Vous en serez informé lors de votre première visite sur le Site. Vous serez alors invité à les accepter, les refuser ou à les paramétrer."
      },
      {
        "type": "paragraph",
        "text": "Les Cookies nécessitant votre consentement (analytiques, publicitaires, personnalisation) ne seront déposés qu’après acceptation expresse de votre part."
      },
      {
        "type": "paragraph",
        "text": "Vos choix (accepter ou refuser) sont conservés pendant 6 mois, puis vous serez de nouveau invité à les paramétrer."
      },
      {
        "type": "paragraph",
        "text": "Gestion des cookies"
      },
      {
        "type": "paragraph",
        "text": "Vous pouvez à tout moment modifier vos préférences via notre outil de gestion des cookies (accessible en bas de page du site) ou via les réglages de votre navigateur."
      },
      {
        "type": "paragraph",
        "text": "Paramétrage selon les navigateurs :"
      },
      {
        "type": "listItem",
        "text": "Internet Explorer : menu « Paramètres » > « Options Internet » > « Confidentialité » > « Paramètres de confidentialité avancés »."
      },
      {
        "type": "listItem",
        "text": "Google Chrome : menu « Paramètres » > « Confidentialité et sécurité » > « Cookies et autres données des sites »."
      },
      {
        "type": "listItem",
        "text": "Safari (Mac) : menu « Réglages » > « Safari » > « Confidentialité et sécurité » > bloquer les cookies si souhaité."
      },
      {
        "type": "listItem",
        "text": "Safari (iPhone) : menu « Réglages » > « Safari » > « Confidentialité » > « Bloquer tous les cookies »."
      },
      {
        "type": "listItem",
        "text": "Android (Chrome) : menu « Paramètres » > « Paramètres de site » > « Cookies »."
      },
      {
        "type": "paragraph",
        "text": "Conséquences du refus"
      },
      {
        "type": "paragraph",
        "text": "Vous pouvez continuer à naviguer sur le site en refusant les Cookies. Cependant, certaines fonctionnalités (comme la lecture de vidéos, la personnalisation ou certains contenus interactifs) peuvent être limitées."
      },
      {
        "type": "heading",
        "text": "Modifications de la politique de confidentialité et de cookies"
      },
      {
        "type": "paragraph",
        "text": "La présente politique de confidentialité et de cookies est susceptible d’évoluer afin de tenir compte des évolutions légales et réglementaires, des recommandations des autorités de protection des données, ainsi que des évolutions de nos pratiques."
      },
      {
        "type": "paragraph",
        "text": "En cas de modification substantielle, les utilisateurs en seront informés par une mention spécifique sur notre site (bandeau d’information ou notification lors de leur prochaine visite). Le cas échéant, un nouvel accord pourra être sollicité, notamment pour les traitements ou cookies nécessitant votre consentement."
      },
      {
        "type": "paragraph",
        "text": "Nous vous invitons à consulter régulièrement la présente politique afin de rester informé de la manière dont nous protégeons vos données personnelles."
      },
      {
        "type": "paragraph",
        "text": "Date d’entrée en vigueur : 01/02/2026"
      }
    ]
  }
] satisfies readonly LegalDocument[];

export const getLegalDocument = (slug: string | undefined) =>
  legalDocuments.find((document) => document.slug === slug);
